export default "__VITE_ASSET__CHcYr_tU__"